import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const RecentTransactionsStyles = makeStyles((theme: Theme) =>
  createStyles({
    label: {
      color: "#002035",
      fontFamily: "Roobert",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "19px",
      letterSpacing: "-0.32px",
    },
    value: {
      color: "#7B858B",
      fontFamily: "Söhne",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "17px",
    },
    layout: {
      padding: "4px 20px 14px 20px",
      borderRadius: "10px",
      background: "#F8F9F9",
    },
    units: {
      color: "#002035",
      fontFamily: "Söhne",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "17px",
    },
    link: { display: "flex", justifyContent: "end" },
    title: {
      color: "#002035",
      fontFamily: "Roobert",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "19px",
      letterSpacing: "-0.32px",
    },
    noContentLabel: {
      color: "#7B858B",
      fontFamily: "Söhne",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "17px",
    },
    here: {
      color: "#7B858B",
      fontFamily: "Söhne",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "17px",
      textDecorationLine: "underline",
    },
  }),
);
